import { render, staticRenderFns } from "./NewsletterDetailsCollapse.vue?vue&type=template&id=7f8ad0e9&scoped=true&"
import script from "./NewsletterDetailsCollapse.vue?vue&type=script&lang=js&"
export * from "./NewsletterDetailsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ad0e9",
  null
  
)

export default component.exports